import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import { Block, Close } from '@material-ui/icons';
import CloseIcon from '@material-ui/icons/Close';
import FavoriteIcon from '@material-ui/icons/Favorite';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import RoomIcon from '@material-ui/icons/Room';
import VisibilityIcon from '@material-ui/icons/Visibility';
import {
  getInfosAccountRestricted,
  checkIfSavedTraining,
  postuleTraining ,
  getInfosDashboard,
  checkIfPostuleTraining,
  savedTraining,
  unSavedTraining,
  connectASchoolPartner,
} from '@webapps/business';
import { useQuery, useRouter } from '@webapps/reactjs-tech-components';
import {
  useAuth,
  useMutation,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import AvatarCompany from 'components/Avatar/AvatarCompany';
import Partenaire from 'components/Icons/Partenaire';
import VerifiedIcon from 'components/Icons/VerifiedIcon';
import { ROUTES_PATH } from 'config/constants';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';

import theme from '../../theme';

const {
  colors: { titleProfilName },
} = theme;

const InfoName = ({
  partnersAccepted,
  partnersRequested,
  partnersReceived,
  handleRefetch,
  accountInfos,
  info = {},
  closeModal,
}) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const { profile } = useAuth();
  const { idUser } = useAuth();

  const { push } = useRouter();

  const { addToast } = useToast();

  const windowWidth = window.innerWidth;

  const postuTraining = async () => {
    await mutatePostuleTraining({
      data: {
        applicant: {
          id: idUser,
        },
        training: {
          id: info?.id,
        },
      },
    });
  };

  const unSaveTraining = async () => {
    await mutateUnSavedTraining({
      idApplicant: idUser,
      idTraining: info?.id,
    });
  };

  const {
    isLoading: isLoadingSavedTraining,
    isSuccess: isSuccessSave,
    mutateAsync: mutateSavedTraining,
  } = useMutation(savedTraining);

  const {
    isLoading: isLoadingPostuleTraining,
    isSuccess: isSuccessPostule,
    mutateAsync: mutatePostuleTraining,
  } = useMutation(postuleTraining);

  const {
    isLoading: isLoadingUnSavedTraining,
    isSuccess: isSuccessUnSave,
    mutateAsync: mutateUnSavedTraining,
  } = useMutation(unSavedTraining);

  const { data: checkSave = {}, refetch } = useQuery(checkIfSavedTraining, {
    key: ['checkSavedTraining'] + idUser + info?.id,
    variables: { idApplicant: idUser, idTraining: info?.id },
  });

  const { data: checkPostule = {}, refetch: refetchPostule } = useQuery(
    checkIfPostuleTraining,
    {
      key: ['checkPostuleTraining'] + idUser + info?.id,
      variables: { idApplicant: idUser, idTraining: info?.id },
    }
  );

  const { data: infoSchoolAccount = {} } = useQuery(getInfosAccountRestricted, {
    key: 'infoSchoolAccount' + info?.school?.id,
    variables: { id: info?.school?.id },
    enabled: !!info?.school?.id,
  });

  useEffect(() => {
    if (isSuccessSave) {
      addToast({
        status: 'success',
        message: 'Formation sauvegardée',
      });
    }

    refetch();
  }, [isSuccessSave]);

  useEffect(() => {
    if (isSuccessPostule) {
      addToast({
        status: 'success',
        message: 'Vous avez postulé à la formation',
      });
    }
    refetchPostule();
  }, [isSuccessPostule]);

  useEffect(() => {
    if (isSuccessUnSave) {
      addToast({
        status: 'success',
        message: 'Formation retirée des sauvegardes',
      });
    }
    refetch();
  }, [isSuccessUnSave]);

  useEffect(() => {
    handleRefetch();
  }, [info.school?.id]);

  const saveTraining = async () => {
    await mutateSavedTraining({
      data: {
        applicant: {
          id: idUser,
        },
        training: {
          id: info?.id,
        },
      },
    });
  };

  const date = new Date();

  const handleOpenVitrine = (id) => {
    push(ROUTES_PATH.SCHOOL_VITRINE, { params: { id }, from: 'map' });
  };

  const { data: images = {} } = useQuery(getInfosDashboard, {
    key: ['imageProfile', info?.school?.id],
    variables: { id: info?.school?.id },
    enabled: typeof info?.school?.id !== 'undefined',
  });

  const {
    error: isErrorConnect,
    isLoading: isLoadingConnect,
    isSuccess: isSuccessConnect,
    mutateAsync: mutateConnect,
  } = useMutation(connectASchoolPartner);

  const reqPartner = async () => {
    await mutateConnect({
      data: {
        businessId: idUser,
        schoolId: info?.school?.id,
      },
    });
  };

  useEffect(() => {
    if (isSuccessConnect) {
      addToast({
        status: 'success',
        message: 'Demande envoyée',
      });
      handleRefetch();
    }
    if(isErrorConnect) {
      addToast({
        status: 'error',
        message: 'Erreur lors de la demande',
      });
    }
  }, [isSuccessConnect, isErrorConnect]);

  return (
    <div className={classes.container}>
      <div className={
        css({
          width: '100%',
          backgroundImage: `linear-gradient(rgba(5, 6, 50, 0.75), rgba(5, 6, 50, 0.75)), url(${images?.profile?.coverImageUrl})`,
          backgroundSize: 'cover',
          backgroundBlendMode: 'darken',
          borderRadius: '10px 10px 0 0px',
          '@media only screen and (max-width:1023px)': {
            borderRadius: 0,
          },
        })
      }>
        <div
          className={cx(
            classes.divInfos,
            css({
              padding: '24px',
              top: 0,
              display: 'flex',
              justifyContent: 'start',
              alignItems: 'center',
              '@media only screen and (max-width:1023px)': {
                '@media only screen and (max-width:1023px)': {
                  flexDirection: 'row',
                  alignItems: 'flex-start',
                  display: 'flex',
                  padding: spacing(2),
                },
              },
            })
          )}
        >
          <AvatarCompany
            width={windowWidth > 1600 ? 130 : 80}
            height={windowWidth > 1600 ? 130 : 80}
            idCompany={info?.school?.id}
          />
          <div className={classes.nameContainer}>
            <div className={cx(global.infoText, classes.name)}>
              <div style={{ marginRight: 5, fontWeight: 700 }}>{info?.school?.name.toUpperCase()}</div>
              <VerifiedIcon color={'#1DA1F2'} className={global.smallIcon} />
            </div>
            <div className={cx(global.mainTitle, classes.titleJob)}>{info?.label}</div>
            <div className={cx(global.infoText, classes.address)}>
              <RoomIcon className={cx(global.smallIcon, classes.imgAdress)} />
              <div>
                {info?.address?.city} {info?.address?.cityCode}{' '}
              </div>
            </div>
          </div>
        </div>
        <div
          className={cx(
            classes.btnsContainer,
            css({
              bottom: 0,
              padding: '0 24px 24px 24px',
              justifyContent: 'start',
              alignItems: 'center',
              display: profile === "SCHOOL" ? 'none' : 'flex',
              '@media only screen and (max-width:1023px)': {
                width: '100%',
                display: 'none',
              },
            })
          )}
        >
          {profile === 'INDIVIDUAL' && (
            <div className={classes.btnaddfavoris}>
              {checkPostule ? (
                <Button
                  className={css({
                    width: '250px',
                  })}
                  disabled
                  variant="outlined"
                >
                  Déjà postulé
                </Button>
              ) : new Date(info?.applicationStartDate?.split('T')[0]) <=
                  date &&
                new Date(info?.applicationClosingDate?.split('T')[0]) >=
                  date ? (
                <Button
                  className={css({
                    width: '250px',
                  })}
                  color="primary"
                  disabled={isLoadingPostuleTraining}
                  onClick={postuTraining}
                  variant="contained"
                >
                  Postuler
                </Button>
              ) : (
                <Button
                  color="primary"
                  style={{
                    backgroundColor: '#E0E0E0',
                    color: '#A6A6A6',
                  }}
                  disabled
                  startIcon={<Block />}
                  variant="contained"
                >
                  Formation fermée
                </Button>
              )}
            </div>
          )}
          {profile === 'BUSINESS' && (
            <div className={css({marginRight: 16})}>
              {partnersAccepted?.find(({ id }) => id === info?.school?.id) && (
                <Button
                  className={css({
                    marginRight: 16,
                    '&:disabled': {
                      color: '#A6A6A6',
                      backgroundColor: '#E0E0E0',
                    },
                  })}
                  startIcon={<Partenaire />}
                  color="primary"
                  variant="contained"
                  disabled
                >
                  <FormattedMessage id="business.dashboard.dashboardBtns.partnerActive" />
                </Button>
              )}
              {accountInfos?.subscription &&
                accountInfos?.subscription.toLowerCase() == 'premium' &&
                infoSchoolAccount?.subscription &&
                infoSchoolAccount?.subscription.toLowerCase() == 'premium' &&
                !partnersAccepted?.find(({ id }) => id === info?.school?.id) &&
                !partnersRequested?.find(({ id }) => id === info?.school?.id) &&
                !partnersReceived?.find(({ id }) => id === info?.school?.id) && (
                  <Button
                    className={css({
                      marginRight: 16,
                      '&:disabled': {
                        color: '#A6A6A6',
                        backgroundColor: '#E0E0E0',
                      },
                    })}
                    startIcon={<Partenaire />}
                    color="primary"
                    onClick={reqPartner}
                    variant="contained"
                  >
                    <FormattedMessage id="business.dashboard.dashboardBtns.partnerbtn" />
                  </Button>
                )}
              {(partnersRequested?.find(({ id }) => id === info?.school?.id) ||
                partnersReceived?.find(({ id }) => id === info?.school?.id)) && (
                <Button
                  startIcon={<Partenaire />}
                  className={css({
                    marginRight: 16,
                    '&:disabled': {
                      color: '#A6A6A6',
                      backgroundColor: '#E0E0E0',
                    },
                  })}
                  color="primary"
                  //   onClick={logiquepartenariat}
                  variant="contained"
                  disabled
                >
                  <FormattedMessage id="business.dashboard.dashboardBtns.partnerPending" />
                </Button>
              )}
              <Button
                className={cx(
                  classes.btnVitrine,
                  css({
                    '&:hover': {
                      backgroundColor: '#F3F7FF',
                      color: '#5A6DA1',
                    },
                  })
                )}
                onClick={() => handleOpenVitrine(info?.school?.id)}
                variant="outlined"
              >
                <VisibilityIcon style={{ marginRight: 5 }} /> Visualiser la
                vitrine
              </Button>
            </div>
          )}
          {profile === 'INDIVIDUAL' && !checkPostule && (
            <div className={classes.btnaddfavoris}>
              {checkSave ? (
                <Button
                  className={css({
                    marginRight: 16,
                    '&:hover': {
                      backgroundColor: '#F3F7FF',
                      color: '#5A6DA1',
                    },
                  })}
                  disabled={isLoadingUnSavedTraining}
                  onClick={unSaveTraining}
                  fullWidth
                  startIcon={<FavoriteIcon color="primary" />}
                  variant="outlined"
                >
                  <FormattedMessage id="AddedToFavorite" />
                </Button>
              ) : (
                <Button
                  className={css({
                    marginRight: 16,
                    '&:hover': {
                      backgroundColor: '#F3F7FF',
                      color: '#5A6DA1',
                    },
                  })}
                  disabled={isLoadingSavedTraining}
                  fullWidth
                  onClick={saveTraining}
                  startIcon={<FavoriteBorderIcon />}
                  variant="outlined"
                >
                  <FormattedMessage id="AddToFavorite" />
                </Button>
              )}
            </div>
          )}
          {profile === 'INDIVIDUAL' && (
            <Button
              className={cx(
                classes.btnVitrine,
                css({
                  '&:hover': {
                    backgroundColor: '#F3F7FF',
                    color: '#5A6DA1',
                  },
                })
              )}
              onClick={() => handleOpenVitrine(info?.school?.id)}
              variant="outlined"
            >
              <VisibilityIcon style={{ marginRight: 5 }} /> Visualiser la
              vitrine
            </Button>
          )}
        </div>
      </div>
      <div>
        <IconButton
          onClick={closeModal}
          className={css({
            zIndex: 2,
            backgroundColor: 'white',
            border: '1px solid #C0D9FF',
            height: '30px',
            width: '30px',
            position: 'absolute',
            top: 20,
            right: 20,
            '&:hover': {
              backgroundColor: 'white',
            },
            '@media only screen and (min-width:1024px)': {
              display: 'none', // Cache la croix pour les écrans larges
            },
            '@media only screen and (max-width:1023px)': {
              display: 'flex', // Affiche la croix pour les écrans étroits
              justifyContent: 'center',
              alignItems: 'center',
            },
          })}
        >
          <CloseIcon />
        </IconButton>
      </div>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    width: '100%',
  },
  btnsContainer: {
    zIndex: 1,
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'center',
    '@media only screen and (max-width:1023px)': {
      marginTop: spacing(2),
      width: '100%',
      display: 'flex',

    },
  },
  btnaddfavoris: {
    marginRight: 16,
    '@media only screen and (max-width:1023px)': {
      marginTop: spacing(2),
      marginLeft: 0,
    },
  },
  btnVitrine: {
    color: '#5A6DA1',
    backgroundColor: '#F3F7FF',
    marginRight: 16,
    '@media only screen and (max-width:1023px)': {
      marginLeft: 0,
    },
  },
  nameContainer: {
    zIndex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginLeft: spacing(2),
    '@media only screen and (max-width:1023px)': {
      // marginLeft: 0, // Alignement pour écrans étroits
      marginTop: spacing(1),
      width: '100%',
    },
  },
  divInfos: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    '@media only screen and (max-width:1023px)': {
      flexDirection: 'column',
      alignItems: 'flex-start',
      padding: spacing(2), // Ajoute du padding pour améliorer le rendu
      display: 'flex', // Affiche les infos dans la vue étroite
    },
  },
  name: {
    color: '#FFFFFF',
    display: 'flex',
    alignItems: 'center',
    marginBottom: 5,
    fontSize: '1rem',
    '@media only screen and (max-width:1023px)': {
      // color: '#152652', // Change la couleur pour les écrans étroits
      fontSize: '1rem',
    },
  },
  address: {
    marginTop: 5,
    marginBottom: 5,
    fontWeight: 400,
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    '@media only screen and (max-width:1023px)': {
      // color: '#152652',
    },
  },
  imgAdress: {
    color: '#FFF',
  },
  gridBtn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    '@media only screen and (max-width:1023px)': {
      marginTop: spacing(2),
      width: '100%',
    },
  },
  titleJob: {
    color: '#FFFFFF',
    fontWeight: 700,
    fontSize: '1.25rem !important',
    '@media only screen and (max-width:1023px)': {
    },
  },
});

InfoName.propTypes = {
  info: PropTypes.object,
};

export default InfoName;
